/**
 * dev  : 刘洋
 * desc : CMS视频通用组件
 * 备注 : 后续可添加播放暂停等事件
 */
<template>
  <section class="comp-video" :class="{'control-hide': isHideControl, 'video-Q20220709101555': isQ20220709101555}" :style="`margin-left: ${marginLeftSet}; margin-right: ${marginRightSet};`">
    <video-player ref="videoPlayer" :options="playerOptions" :playsinline="true" @play="onPlayerPlay()"></video-player>
    <div v-if="imgLink" :style="{backgroundImage: 'url(' +imgLink+ ')'}" class="img-cover"></div>
  </section>
</template>

<script>
import 'video.js/dist/video-js.css'
import { videoPlayer } from 'vue-video-player'

export default {
  props: {
    compProps: {
      type: Object,
      default: function() {
        return {}
      }
    },
    payLoad: {
      type: Object,
      default: function() {
        return {}
      }
    },
    elementId: {
      type: Number
    },
    elementName: {
      type: String
    }
  },
  // 添加全屏事件
  // data() {
  //   return {
  //     events: ['fullscreenchange']
  //   }
  // },
  computed: {
    player() {
      return this.$refs.videoPlayer.player
    },
    // 视频组件参数
    playerOptions() {
      // let fullScreenEnable = true
      // if (process.env.VUE_APP_LOCAL === 'Q') {
      //   const { Sniff } = require('@/utils/q_sniff')
      //   if (Sniff.qunar) {
      //     fullScreenEnable = false
      //   }
      // }
      const { interactiveEnable } = this.compProps.privateProps
      // 是否自动播放，不可交互时，自动播放
      const autoPlay = !interactiveEnable
      // 是否可交互，默认为不可交互
      let controlBar = false
      if (this.compProps.privateProps.interactiveEnable) {
        controlBar = {
          timeDivider: true,
          durationDisplay: true,
          remainingTimeDisplay: true, // 剩余时间
          fullscreenToggle: true // 全屏按钮
        }
      }
      return {
        // playbackRates: [0.7, 1.0, 1.5, 2.0], // 播放速度
        autoplay: autoPlay, // 如果true,浏览器准备好时开始自动播放。
        muted: autoPlay, // 默认情况下将会消除任何音频。
        loop: this.compProps.privateProps.isLoop, // 导致视频一结束就重新开始。
        preload: 'none', // 建议浏览器在<video>加载元素后是否应该开始下载视频数据。auto浏览器选择最佳行为,立即开始加载视频（如果浏览器支持）
        language: 'zh-CN',
        aspectRatio: this.compProps.privateProps.proportion || '16:9', // 将播放器置于流畅模式，并在计算播放器的动态大小时使用该值。值应该代表一个比例 - 用冒号分隔的两个数字（例如"16:9"或"4:3"）
        fluid: true, // 当true时，Video.js player将拥有流体大小。换句话说，它将按比例缩放以适应其容器。
        sources: [{
          type: 'video/mp4',
          src: this.picHost + this.compProps.video // url地址
        }],
        poster: this.picHost + this.compProps.poster, // 你的封面地址
        notSupportedMessage: '此视频暂无法播放，请稍后再试', // 允许覆盖Video.js无法播放媒体源时显示的默认信息。
        controlBar
      }
    },
    marginLeftSet() {
      if (this.compProps.privateProps.marginLeft) {
        return this.compProps.privateProps.marginLeft + 'px'
      } else {
        return '0'
      }
    },
    marginRightSet() {
      if (this.compProps.privateProps.marginRight) {
        return this.compProps.privateProps.marginRight + 'px'
      } else {
        return '0'
      }
    },
    imgLink() {
      return this.compProps.imgLink ? `${this.picHost}${this.compProps.imgLink}` : ''
    },
    isHideControl() {
      return !this.compProps.privateProps?.interactiveEnable
    },
    isQ20220709101555() {
      return ['Q20220709101555'].indexOf(this.$route.query.id) > -1
    }
  },
  mounted() {
    if (!this.compProps.privateProps.interactiveEnable && this.platformEnv.isWxEnv) {
      document.addEventListener('touchstart', () => {
        this.$refs.videoPlayer.player.play()
      })
    }
  },
  methods: {
    // 视频播放时触发埋点
    onPlayerPlay() {
      window._fas && window._fas.setCustomTrack({
        eventname: 'C_HOME_CMS_TRAVELAROUND_ELEMNT_CLICK',
        ext: {
          elementId: this.elementId,
          elementName: this.elementName,
          elementType: 1,
          url: this.picHost + this.compProps.video,
          rank_list_id: this.$root.promotionId,
          rank_list_name: this.$root.htmlTitle
        }
      })
    }
  },
  components: {
    videoPlayer
  }
}
</script>
<style lang="scss">
.comp-video {
  position: relative;
  .video-js {
    background-color: transparent;
    // border-radius: 0.4rem;
    .vjs-tech {
      object-fit: fill;
      // border-radius: 0.4rem;
    }
    .vjs-big-play-button {
      border-radius: 50%;
      width: 1.5em;
      top: 50%;
      left: 50%;
      margin-top: -0.75em;
      margin-left: -0.75em;
      z-index: 99;
    }
    .vjs-poster {
      background-color: transparent;
      background-size: cover;
      // border-radius: 0.4rem;
    }
    .vjs-control-bar {
      // border-radius: 0 0 0.4rem 0.4rem;
      z-index: 99;
    }
  }
  &.control-hide {
    .video-js .vjs-big-play-button {
      display: none;
    }
  }
}
</style>
<style lang="scss" scoped>
@function size($n) {
  @return $n/375 * 100vw;
}
.img-cover {
  position: absolute;
  top: 0;
  height: 100%;
  width: 100%;
  background: transparent center no-repeat;
  background-size: contain;
}
/deep/.video-Q20220709101555 {
  background: url('https://pic.tujia.com/upload/festatic/publicImages/video_bg1.jpg') no-repeat;
  background-size: 100%;
  padding: size(22) size(21) 0;
  height: size(210);
  box-sizing: border-box;
  .video-js {
    border-radius: size(10);
    .vjs-tech {
      border-radius: size(10);
    }
    .vjs-poster {
      border-radius: size(10);
    }
  }
}
</style>
